export const motionComponentSymbol = Symbol.for("motionComponentSymbol");
//# sourceMappingURL=symbol.js.map